import Sentry from "../../../common/config/config.sentry";

const sanitizeContext = (context = {}) => {
    const cleanContext = { ...context };
    if (cleanContext.userMessage) {
        delete cleanContext.userMessage;
    }
    return cleanContext;
};

const captureException = (error, context) => {
    try {
        Sentry.captureException(error, { extra: sanitizeContext(context) });
    } catch (captureError) {
        if (!import.meta.env.PROD) {
            console.error("Sentry capture failed", captureError);
        }
    }
};


export const errorService = {
    handleError(error, context = {}) {

        captureException(error, context);

        if (!import.meta.env.PROD) {
            console.error(error);
        }

        return error;
    }
};
